import React, {useState} from 'react'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import calendarIcon from '../../../_metronic/images/calendarIcon.svg'
import calendarWhiteIcon from '../../../_metronic/images/calendarWhiteIcon.svg'
import SVG from 'react-inlinesvg'
import moment from 'moment'

export default function DateRangePickers({getdataFromDateFilter, colors}: any) {

  const [filterDate, setFilterDate] = useState<any>('Last 30 Days')
 const dateFormat = 'YYYY-MM-DD'

  // calls getdataFromDateFilter function from props
  // with fromDate & toDate in UTC time based on filter
  const daysFilter = (daysTobeFilter: any) => {
    const date = new Date()
    switch (daysTobeFilter) {
      case 'Today':
        const fromDate = new Date(moment(date).format(dateFormat) + 'T00:00:00').toISOString()
        const toDate = new Date(moment(date).format(dateFormat) + 'T23:59:00').toISOString()
        getdataFromDateFilter(fromDate, toDate, daysTobeFilter)
        break

      case 'Last 30 Days':
        const _fromDate = new Date(
          moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
        ).toISOString()
        const _toDate = new Date(moment(date).format(dateFormat) + 'T23:59:00').toISOString()
        getdataFromDateFilter(_fromDate, _toDate, daysTobeFilter)
        break

      case 'Yesterday':
        date.setDate(date.getDate() - 1)
        const fromDateYesterday = new Date(
          moment(date).format(dateFormat) + 'T00:00:00'
        ).toISOString()
        const toDateYesterday = new Date(
          moment(date).format(dateFormat) + 'T23:59:00'
        ).toISOString()
        getdataFromDateFilter(fromDateYesterday, toDateYesterday, daysTobeFilter)
        break

      case 'Last Week':
        const lastWeekStartDate = new Date(
          moment(moment().subtract(1, 'weeks').startOf('weeks').toDate()).format(dateFormat) +
            'T00:00:00'
        ).toISOString()
        const lastWeekEndDate = new Date(
          moment(moment().subtract(1, 'weeks').endOf('weeks').toDate()).format(dateFormat) +
            'T23:59:00'
        ).toISOString()
        getdataFromDateFilter(lastWeekStartDate, lastWeekEndDate, daysTobeFilter)
        break

      case 'This Week':
        const thisWeekStartDate = new Date(
          moment(moment().startOf('weeks').toDate()).format(dateFormat) + 'T00:00:00'
        ).toISOString()
        const thisWeekEndDate = new Date(
          moment(moment().endOf('weeks').toDate()).format(dateFormat) + 'T23:59:00'
        ).toISOString()
        getdataFromDateFilter(thisWeekStartDate, thisWeekEndDate, daysTobeFilter)
        break

      case 'This Month':
        const thisMonthStartDate = new Date(
          moment(moment().startOf('month').toDate()).format(dateFormat) + 'T00:00:00'
        ).toISOString()
        const thisMonthEndDate = new Date(
          moment(moment().endOf('month').toDate()).format(dateFormat) + 'T23:59:00'
        ).toISOString()
        getdataFromDateFilter(thisMonthStartDate, thisMonthEndDate, daysTobeFilter)
        break

      case 'Last Month':
        const lastMonthStartDate = new Date(
          moment().subtract(1, 'month').startOf('month').toDate()
        ).toISOString()
        const lastMonthEndDate = new Date(
          moment().subtract(1, 'month').endOf('month').toDate()
        ).toISOString()
        getdataFromDateFilter(lastMonthStartDate, lastMonthEndDate, daysTobeFilter)
        break

      case 'Last Quarter':
        const from = new Date(
          moment(moment().subtract(1, "quarter").startOf("quarter").toDate()).format(
            dateFormat
          ) + "T00:00:00"
        ).toISOString()
        const to = new Date(
          moment(moment().subtract(1, 'quarter').endOf('quarter').toDate()).format(dateFormat) +
          'T23:59:00'
        ).toISOString()
        getdataFromDateFilter(from, to, daysTobeFilter)
        break

      case 'This Quarter':
        const thisQuarterStartDate = new Date(
          moment(
            moment().startOf("quarter").toDate()
          ).format(dateFormat) + "T00:00:00"
        ).toISOString()
        const thisQuarterEndDate = new Date(
          moment(
          moment().endOf("quarter").toDate()
            ).format(dateFormat) + 'T23:59:00'
          ).toISOString()
        getdataFromDateFilter(thisQuarterStartDate, thisQuarterEndDate, daysTobeFilter)
        break

      case 'Year To Date':
        const YTDStartDate = new Date(
          moment().startOf('year').format(dateFormat) + 'T00:00:00'
        ).toISOString()
        const YTDEndDate = new Date(moment(date).format(dateFormat) + 'T23:59:00').toISOString()
        getdataFromDateFilter(YTDStartDate, YTDEndDate, daysTobeFilter)
        break

      default:
        break
    }
  }

  // this function is only for custome date filter
  // sets the date range label in datePicker 
  // and calls getdataFromDateFilter function from props
  const handleApply = (startDate: any, endDate: any) => {
    const _endDate = new Date(
      moment(new Date(endDate)).format(dateFormat) + 'T23:59:00'
    ).toISOString()
    const _startDate = new Date(
      moment(new Date(startDate)).format(dateFormat) + 'T00:00:00'
    ).toISOString()
    const getFullYearStDt = new Date(startDate).getFullYear()
    const getMonthStDt = new Date(startDate).getMonth() + 1
    const getDateStDt = new Date(startDate).getDate()
    const getFullYearEnDt = new Date(endDate).getFullYear()
    const getMonthEnDt = new Date(endDate).getMonth() + 1
    const getDateEnDt = new Date(endDate).getDate()
    const tempFilterDt = `${getFullYearStDt}/${getMonthStDt}/${getDateStDt} - ${getFullYearEnDt}/${getMonthEnDt}/${getDateEnDt}`
    setFilterDate(tempFilterDt)
    getdataFromDateFilter(_startDate, _endDate,`Custom Range_${getFullYearStDt}-${getMonthStDt}-${getDateStDt}_to_${getFullYearEnDt}-${getMonthEnDt}-${getDateEnDt}`)
  }

  // used to handle the event from datePicker
  const handleEvent = (event: any, picker: any) => {
    if (event.type === 'apply') {
      // if custom Range filter
      if (picker.chosenLabel === 'Custom Range') {
        handleApply(picker.startDate._d, picker.endDate._d)
      } else {
        // if other than custom Range filter
        daysFilter(picker.chosenLabel)
        setFilterDate(picker.chosenLabel)
      }
    }
  }

  return (
    <div className='date-range-picker'>
      <DateRangePicker
        initialSettings={{
          startDate: moment().subtract(29, 'days').toDate(),
          endDate: moment().toDate(),
          ranges: {
            Today: [moment().toDate(), moment().toDate()],
            Yesterday: [
              moment().subtract(1, 'days').toDate(),
              moment().subtract(1, 'days').toDate(),
            ],
            'Last Week': [moment().subtract(6, 'days').toDate(), moment().toDate()],
            'This Week': [
              moment(moment().startOf('weeks').toDate()),
              moment(moment().endOf('weeks').toDate()),
            ],
            'This Month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
            'Last 30 Days': [moment().subtract(29, 'days').toDate(), moment().toDate()],
            'Last Month': [
              moment().subtract(1, 'month').startOf('month').toDate(),
              moment().subtract(1, 'month').endOf('month').toDate(),
            ],
            'Last Quarter': [
              moment().subtract(3, 'month').startOf('month').toDate(),
              moment().subtract(1, 'month').endOf('month').toDate(),
            ],
            'This Quarter': [
              moment().quarter(moment().quarter()).startOf('month').toDate(),
              moment().quarter(moment().quarter()).add(2, 'month').endOf('month').toDate(),
            ],
            'Year To Date': [moment().startOf('year').toDate(), moment().toDate()],
          },
        }}
        onEvent={handleEvent}
      >
         <button
         className={`${colors === 'white' ? 'btn btn-primary btn-active-primary' : 'btn btn-white btn-active-white btn-active-color-primary btn-color-primary'}  
         btn-sm mh-38px d-flex align-items-center justify-content-between`}
         style={{width:"140px",height: '43px'}}
       >
         <SVG src={colors === 'white' ? calendarWhiteIcon : calendarIcon} className='svg-icon svg-icon-2' />
         {filterDate}
       </button>
      </DateRangePicker>
    </div>
  )
}
